export enum WebSites {
  AlifTj = 'https://alif.tj/',
}
